export default {
  site: {
    title: 'Shas Illuminated',
    title_mishna: 'Mishna Illuminated',

    subtitle: 'Shiurim Series',
    tagline: 'Unlocking the Entire Shas. B’Iyun.',
    metaWithName: '{{name}} - Shas Illuminated. Reach higher',
    metaWithoutName: 'Shas Illuminated. Reach higher',
    metaTorahWithName: '{{name}} - Torah - Hadaf B’Iyun',
    metaTorahWithoutName: 'Torah - Hadaf B’Iyun',
    metaMishnahWithName: '{{name}} - Mishna - Hadaf B’Iyun',
    metaMishnahWithoutName: 'Mishna - Hadaf B’Iyun',
    aboutUs: 'About SI',
    downloads: 'Downloads',
    titleWithSubtitle: 'Shas Illuminated Series',
  },
  more: 'More',
  live: 'Live',
  login: 'Login',
  register: 'Register',
  downloadPdf: 'Download PDF',
  follow: 'Follow',
  unfollow: 'Unfollow',
  previous: 'Previous',
  next: 'Next',
  viewAll: 'View All',
  topic: 'Topic',
  topics: 'Topics',
  search: 'Search',
  speaker: 'Speaker',
  speakers: 'Speakers',
  masechta: 'Masechta',
  mishnaMasechta: 'Mishna Masechta',
  daf: 'Daf',
  todayDaf: "Today's Daf",
  sortBy: 'Sort By',
  jumpToDaf: 'Jump to Daf',
  jumpToChapter: 'Jump to Chapter',
  jumpToMishna: 'Jump to Mishna',
  filterBy: 'Filter By',
  dedicatedBy: 'Dedicated By: {{ name }}',
  sponsoredBy: 'Sponsored by',
  sponsoredByMessageShas: 'This daf is sponsored by {{ names }}.',
  sponsoredByMessageMishna: 'This mishna is sponsored by {{ names }}.',
  dedicatedTo: 'Dedicated to',
  showDaf: 'Show Daf',
  name: 'Name',
  send: 'SEND',
  date: 'Date',
  time: 'Time',
  length: 'Length',
  mobile: 'Mobile',
  message: 'Message',
  actions: 'Actions',
  title: 'Title',
  months: 'Months',
  daily: 'daily',
  never: 'never',
  or: 'OR',
  fullName: 'Full Name',
  phoneNumber: 'Phone Number',
  address1: 'Address 1',
  address2: 'Address 2',
  city: 'City',
  podcasts: 'Podcasts',
  haskamos: 'Haskamos',
  torahResources: 'Torah Resources',
  torahShiurim: 'Torah Shiurim',
  zipPostal: 'ZIP / Postal',
  stateProvinceRegion: 'State / Province / Region',
  email: 'Email',
  filterShiur: 'Filter Shiurim',
  magidShiur: 'Magid Shiur',
  magideiShiur: 'Magidei Shiur',
  id: 'ID',
  shiur: 'Shiur',
  shiurim: 'Shiurim',
  contact: 'Contact',
  donate: 'Donate',
  comment: 'Comment',
  delete: 'Delete',
  playOrDownload: 'Play/Download',
  masechtos: 'Masechtos',
  selectMasechta: 'Select a Masechta',
  hadafBeiyunShiur: 'Shas Illuminated Magidei Shiur',
  allMagideiShiur: 'Torah Illuminated Magidei Shiur',
  mishnaMagideiShiur: 'Mishna Illuminated Magidei Shiur',
  mishnaIlluminatedShiurimSeries: 'Mishna Illuminated Magidei Shiur',

  searchShiurim: 'Search Shiurim',
  filterMagidShiur: 'Filter Magid Shiur',
  filterByMagidShiur: 'Filter By Magid Shiur',
  filterTopic: 'Filter Topic',
  filterByBook: 'Filter By Book',
  filterByTopic: 'Filter By Topic',
  filterByTopicCategory: 'Filter By Category',
  filterBySubTopic: 'Filter By SubTopic',
  removeSavedShiurim: 'Remove Saved Shiurim',
  saveShiurim: 'Save Shiurim',

  noTopicsMatch: 'No Topics Match: {{ query }}',
  records: 'Records: {{ count }}',
  askResendEmailInvite: 'Do you want to resend account verification email?',
  thoughtsOnShiur: 'Your thoughts on this shiur',
  privacy_policy: 'Privacy Policy',
  terms_and_conditions: 'Terms and Conditions',
  topicCategories: 'Topic Categories',
  allTopics: 'All Topics',

  mishnaShiurTitle: '{{ masechta }} Perek {{ chapter }} Mishna {{ mishna }}',
  mishnaShiurTitleWithSpeaker: '{{ masechta }} Perek {{ chapter }} Mishna {{ mishna }} by {{ speaker }}',
  mishnaShiurTitleWithMessageAndSpeaker: '{{ masechta }} Perek {{ chapter }} Mishna {{ mishna }} {{ message }} by {{ speaker }}',
  perek: 'Perek',
  mishna: 'Mishna',
  verificationCode: 'Verification Code',
  verify: 'Verify',
  submitCode: 'Submit Code',
  goBack: 'Go Back',
  cancelVerification: 'Cancel Verification and Log out',
  update: 'Update',
  saved: 'Saved',
  pleaseEnterVerificationCode: 'Please enter verification code sent to your phone.',
  requestPhoneCall: 'Request phone call',
  resendCode: 'Resend code',
  errorWhileVerifyingCode: 'Error while verifying the code. Please try again.',
  phoneFieldDescription: 'Alphabets, dashes and other special characters are not allowed.',
  registerPhoneFieldDescription: 'Alphabets, dashes and other special characters are not allowed. You will need to verify your phone to sign up.'
};
